import { useNavigate } from 'react-router-dom';
import './ArticleCard.css';

const ClockIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
  </svg>
);

const CalendarIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

const BookIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" /><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
  </svg>
);

export const ArticleCard = ({
  image,
  tags,
  uploadTime,
  duration,
  date,
  dateLine1,
  dateLine2,
  publicationName,
  views,
  title,
  description,
  slug,
}) => {
  const navigate = useNavigate();
  const hasTags = Array.isArray(tags) && tags.length > 0;
  const metaDate = date || [dateLine1, dateLine2].filter(Boolean).join(' ');
  const clockLabel = uploadTime || duration;
  const sourceLabel = publicationName || views;

  return (
    <div
      className="article-card"
      onClick={() => slug && navigate(`/news-articles/${slug}`)}
      style={{ cursor: slug ? 'pointer' : 'default' }}
    >
      <div className="article-card__thumb">
        <img src={image} alt={title} className="article-card__img" />
      </div>

      <div className="article-card__body">
        <div className="article-card__meta">
          {clockLabel ? (
            <span className="article-card__meta-item">
              <ClockIcon />
              <span className="article-card__meta-text">{clockLabel}</span>
            </span>
          ) : null}

          {metaDate ? (
            <span className="article-card__meta-item">
              <CalendarIcon />
              <span className="article-card__meta-text">{metaDate}</span>
            </span>
          ) : null}

          {sourceLabel ? (
            <span className="article-card__meta-item article-card__meta-item--source">
              <BookIcon />
              <span className="article-card__meta-text">{sourceLabel}</span>
            </span>
          ) : null}
        </div>

        <h4 className="article-card__title">{title}</h4>
        {description ? <p className="article-card__desc">{description}</p> : null}
        {hasTags ? (
          <div className="article-card__tags">
            {tags.map((tag) => (
              <span key={tag} className="article-card__tag">{tag}</span>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};
